export default __webpack_public_path__ + "static/media/dcp.07cf995f.svg";